import React from 'react';
import { connect } from 'react-redux';
import {
  updateWaitingAreaSmsNotification,
  resetWaitingAreaSmsNotificationForm,
  updateWaitingAreaSmsNotificationForm,
} from '../../../../actions/waitingArea';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowUpdateSmsNotificationModal } from '../../../../actions/modal';
import { clone } from '../../../../reducers/helper.js';
import objectAssign from 'object-assign';

@connect(mapStateToProps)
export default class RightPanelUpdateSmsNotification extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  updateWaitingAreaSmsNotification = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'updateWaitingAreaSmsNotificationForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      console.log(!areThereErrors && !window.$(e.target).hasClass('disable'));
      let cb = () => {
        let show = false;
        this.props.dispatch(updateShowUpdateSmsNotificationModal(show));
        this.resetForm();
      };
      if (
        !this.props.waitingAreaSmsNotificationForm.mobilePhoneNumber ||
        this.props.waitingAreaSmsNotificationForm.mobilePhoneNumber == ''
      ) {
        //if phone number is empty, we set the time to 0;
        var formData = clone(this.props.waitingAreaSmsNotificationForm);
        formData.secondsIntervalToSmsSendNotification = 0;
        this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification = 0; //mutating the state as we need it right next

        formData.myProviderStatus = this.props.myProviderStatus;
        this.props.dispatch(updateWaitingAreaSmsNotificationForm(formData));
      }
      this.props.dispatch(
        updateWaitingAreaSmsNotification(this.props.waitingArea.id, this.props.waitingAreaSmsNotificationForm, cb)
      );
    }
  };

  cancelUpdateWaitingAreaSmsNotification = () => {
    this.props.dispatch(hideGlobalMessage()); //in case there are errors on screen from previous failed actions
    let show = false;
    this.props.dispatch(updateShowUpdateSmsNotificationModal(show));
    this.resetForm();
  };

  resetForm = () => {
    this.props.dispatch(resetWaitingAreaSmsNotificationForm());
  };

  render() {
    let saveClasses =
      'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ';
    let clearClasses = 'ui  labeled icon button icon left-text color-black max-width   mrlnull mrbnull mrbm';
    return (
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="2"
          type="button"
          onClick={this.resetForm}
          className={this.props.waitingAreaSmsNotificationForm.updating ? clearClasses + '  disable ' : clearClasses}
        >
          {APP.LANGUAGE.Clear} <i className="erase  icon" />
        </button>
        <button
          data-group="updateWaitingAreaSmsNotificationForm"
          type="button"
          tabIndex="3"
          onClick={this.updateWaitingAreaSmsNotification}
          className={this.props.waitingAreaSmsNotificationForm.updating ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          type="button"
          tabIndex="4"
          onClick={this.cancelUpdateWaitingAreaSmsNotification}
          className="ui   labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);

  return {
    waitingArea: waitingArea,
    waitingAreaSmsNotificationForm: state.waitingAreaReducer.waitingAreaSmsNotificationForm,
    myProviderStatus: waitingArea.myProviderStatus,
  };
}
